import { useMemo } from "react"
import type { LandingData } from "../data/types"
import type { LandingMotionState } from "../lib/landing-motion"

const SPECK_COUNT = 96
const CHAPTERS = ["GLOBE", "SIGNAL", "LATTICE", "RATES", "ATLAS", "TERMINAL", "COVERAGE", "HANDOFF"]

function generateSpecks(seed: number) {
  let s = seed
  const rand = () => {
    s = (s * 1664525 + 1013904223) >>> 0
    return s / 0xffffffff
  }
  const shadows: string[] = []
  for (let i = 0; i < SPECK_COUNT; i++) {
    const x = Math.round(rand() * 2400 - 600)
    const y = Math.round(rand() * 1600 - 200)
    const a = (0.18 + rand() * 0.5).toFixed(2)
    const blur = rand() < 0.18 ? 4 : 0
    shadows.push(`${x}px ${y}px ${blur}px rgba(20, 216, 180, ${a})`)
  }
  return shadows.join(", ")
}

export function StaticFallback({ data, motion }: { data: LandingData; motion: LandingMotionState }) {
  const section = motion.section
  const chapter = CHAPTERS[motion.sectionIndex] || CHAPTERS[0]
  const speckShadows = useMemo(() => generateSpecks(20260428), [])
  return (
    <div id="static-scene" data-chapter={motion.sectionIndex} aria-hidden="true">
      <div className="static-grid" style={{ transform: `perspective(800px) rotateX(${62 - motion.sectionIndex * 1.6}deg) translateY(${22 - motion.sectionIndex * 0.9}vh)` }} />
      <div className="static-specks" style={{ boxShadow: speckShadows }} />
      <div className="static-scan" style={{ transform: `translate3d(${(motion.localProgress - 0.5) * 120}vw, 0, 0)` }} />
      <div className="static-orbit" style={{ transform: `translate(-50%, -50%) rotate(${section * 18}deg)` }} />
      <div className="static-readout mono">
        <span>{chapter}</span>
        <span>{data.stats.symbols} SYMBOLS</span>
        <span>{data.stats.exchanges} EXCHANGES</span>
        <span>{data.stats.news_articles} ARTICLES</span>
      </div>
    </div>
  )
}
